<template>
  <v-toolbar
      class="assistant games-toolbar mb-3 px-2"
      :elevation="4"
      height="75"
      max-height="75"
  >
    <v-row justify="space-between" align="center">
      <div class="toolbar-right">
        <div class="user-tools d-flex flex-row pr-4 align-center">
          <v-icon
              @click="toggleUserMenu"
              class="ml-3 user-menu-toggler"
              color="grey lighten-1"
              large
          >
            mdi-account-circle
          </v-icon>
          <toolbar-upgrade-btn class="mx-2 hidden-sm-and-down " @click="goToUpgradePage" />
          <create-game-btn v-if="subscription" class="hidden-sm-and-down "/>
        </div>
      </div>
      <div  class="hidden-sm-and-down">
        <v-row justify="center" v-if="canShowInToolbar">
            <v-text-field
                v-model="gameName"
                class="toolbar-name"
                append-icon="mdi-pencil"
                solo
                single-line
                dense
                rounded
                hide-details
                hide-selected

                @input="gameNameChange"
            >
            </v-text-field>
        </v-row>
        <v-row v-else>
            <v-select
                v-model="filterType"
                :items="translatedTypes"
                item-text="translatedName"
                item-value="id"
                clearable
                dense
                chips
                small-chips
                hide-details
                hide-selected
                rounded
                solo
                :label="$t('pages.mygames.gameType')"
                @change="onTypeFilter"
            >
            </v-select>
        </v-row>
      </div>
      <div class="px-2">
        <a href="/">
          <v-img width="150" src="/img/clapLabWidth.png" />
        </a>
      </div>
    </v-row>

    <game-edit-dialog
        v-model="editGameDialogOpen"
        @close="editGameDialogOpen = false"
    />


  </v-toolbar>
</template>

<script>
import { types } from "../store/modules/Game.module";
import ToolbarUpgradeBtn from "./ToolbarUpgradeBtn.vue";
import CreateGameBtn from "./CreateGameBtn";
import ShareDialog from "../view/share/ShareDialog.vue";

import GameEditDialog from "../view/games/GameEditDialog";
import { types as tagTypes } from "src/store/modules/Tag.module";
import { types as typeTypes } from "src/store/modules/Type.module";
import { mapGetters } from "vuex";
import { gameTypeTranslate } from "src/helpers/Utilities";

export default {
  name: "GamesToolbar",
  components: {
    GameEditDialog,
    CreateGameBtn,
    ShareDialog,
    ToolbarUpgradeBtn,
  },
  data() {
    return {
      editGameDialogOpen: false,
      shareGame: null,
      filterType: "",
      filterSearch: "",
      gameName: "",
      gameNameDebounce: null,
    };
  },
  computed: {
    ...mapGetters([
      "companyName",
      "isCompany",
    ]),
    auth() {
      return this.$store.state.AuthModule.user;
    },
    gamesCount() {
      return this.$store.getters.gamesCount;
    },
    game() {
      return this.$store.getters.game;
    },
    isNew() {
      return this.game.id === undefined;
    },
    canShowInToolbar() {
      return (
          this.$route.name === "game-form" &&
          this.game?.id == this.$route.params.id
      );
    },
    canCreateGame() {
      return this.$store.getters.canCreateGame;
    },
    subscription() {
      return this.$store.getters.subscription;
    },
    gamesInPlan() {
      return this.$store.getters.gamesInPlan;
    },
    isAdmin() {
      return this.$store.getters.isAdmin;
    }, isTeamHead() {
      return this.$store.getters.isTeamHead;
    },
    plan() {
      //There are two names for the free plan in ClapWay, so I'm checknig both of them
      if (
          !!this.subscription &&
          ["FreeLab", "חינמית"].includes(this.subscription.plan)
      ) {
        return this.$t("generics.free");
      } else {
        return this.$t("toolbar.proPlan");
      }
    },
    isSelectPlanPage() {
      return this.$route.path === "/plans";
    },
    isCreateGameScreen() {
      return this.$store.getters.isCreateGameScreen;
    },
    breakPoint() {
      return this.$vuetify.breakpoint.name;
    },
    maxActionBtnWidth() {
      switch (this.breakPoint) {
        case "xs":
          return "12";
        case "sm":
          return "12";
        case "md":
          return "18";
        default:
          return "20";
      }
    },
    types() {
      return this.$store.state.TypeModule.types;
    },
    translatedTypes() {
      return this.types.map((type) => ({
        ...type, // Spread the original type object (includes id, name, etc.)
        translatedName: gameTypeTranslate(type.name), // Add translated name
      }));
    },
  },
  methods: {

    toggleUserMenu() {
      this.$store.commit("toggleUserMenu");
    },

    onEditGame() {
      this.editGameDialogOpen = true;
    },


    goToUpgradePage() {
      this.$router.push({ name: "plans-page", query: { hf: "t" } });
    },
    onTypeFilter() {
      this.$store.commit(types.FILTER_TYPE, this.filterType);
    },
    onSearchFilter() {
      this.$store.commit(types.FITLER_SEARCH, this.filterSearch);
    },
    gameNameChange() {
      let game = this.game;
      let gameName = this.gameName;
      game.name = this.gameName;
      clearTimeout(this.gameNameDebounce);
      this.gameNameDebounce = setTimeout(() => {
        this.$store.dispatch(types.UPDATE, { ...game, name: gameName });
        console.log("Sending game save event");
      }, 600);
    },
  },
  created() {
    if (!this.isAdmin) {
      this.$store.dispatch(types.COUNT);
    }
    this.type = this.$route.query.type_id;
    // this.$store.dispatch(tagTypes.FETCH);
    this.$store.dispatch(typeTypes.FETCH);
  },
  watch: {
    game: function (val) {
      if (val.id) {
        this.shareGame = val;
        if (this.gameName != val.name) this.gameName = val.name;
      }
    }
  },
};
</script>

<style lang="scss">
.toolbar-name input {
  text-align: center;
}
</style>

<style lang="scss" scoped>

.game-actions-container {
  margin-top: 30px;
}

.game-toolbar-btn {
  margin-right: 10px !important;
  margin-left: 10px !important;
}

.lang-select {
  width: 100px;
  height: 35px;
}

.games-toolbar {
  background: white;
  //   box-shadow:0px 0px 20px 0px rgb(0 0 0 / 45%);
  color: #ed217c !important;
  z-index: 2;

  a {
    color: #ed217c !important;
  }

  .toolbar-right {
    span {
      font-weight: 400;
    }
  }
}

lang-select-container {
  max-width: 150px;
}

.gameModesContainer {
  position: relative;
}

.gameModes {
  position: absolute;
  background: white;
  width: 150px;
  text-align: right;
  right: -60px;
  top: 50px;
}

.game-name {
  display: inline-block;
  font-weight: bold;
  font-size: 0.85rem;
  @media (min-width: 600px) {
  }

  @media (min-width: 960px) {
    font-size: 1.1rem;
  }

  @media (min-width: 1264px) {
    font-size: 1.3rem;
  }
}

.toolbar-text {
  font-size: 0.7rem;

  @media (min-width: 960px) {
    font-size: 0.8rem;
  }

  @media (min-width: 1264px) {
    font-size: 0.85rem;
  }
}
</style>
